<script lang="ts">
    import { auth } from "./lib/auth.svelte.js";
    import ErrorMessage from "./lib/components/common/error-message.svelte";
    import LoadingMessage from "./lib/components/common/loading-message.svelte";
    import OrganizationSelect from "./lib/components/organization-select.svelte";
    import { useURL, currentRelativeURL } from "./lib/url.svelte.js";
    import Redirect from "./lib/components/common/redirect.svelte";
    import { type Page, useRoute } from "./lib/route.svelte.js";
    import { addDebug } from "./lib/components/common/debug.svelte";

    const { pages }: { pages: Page[] } = $props();

    const session = auth.useSession();
    const organization = auth.useActiveOrganization();
    const url = useURL();
    const route = useRoute();
    const page = $derived(pages.find((x) => x.route === route.current?.route));
    addDebug("URL", () => url);
    addDebug("session", () => $session);
    addDebug("organization", () => $organization);
</script>

<div class="h-screen w-screen">
    {#if page}
        {@const { default: Page, sessionRequired = true, adminRequired = false, organizationRequired = true } = page}
        <!-- temporary hack for approval tasks -->
        {#if sessionRequired && (page.route !== "/" || window.__TURIAN_ENTRY__ !== "browserExtension")}
            {#if $session.isPending}
                <LoadingMessage />
            {:else if $session.error || !$session.data || (adminRequired && $session.data.user.role !== "admin")}
                <Redirect route="/signin" query={{ dest: currentRelativeURL() }} />
            {:else if organizationRequired}
                {#if $organization.isPending}
                    <LoadingMessage />
                {:else if $organization.error}
                    <ErrorMessage e={$organization.error} />
                {:else if !$organization.data}
                    <div class="flex size-full items-center justify-center">
                        <div class="w-80">
                            <OrganizationSelect />
                        </div>
                    </div>
                {:else}
                    <Page />
                {/if}
            {:else}
                <Page />
            {/if}
        {:else}
            <Page />
        {/if}
    {:else}
        Not found
    {/if}
</div>
